import React from "react";
import Link from "@insightfulscience/atomic-react/Link";
import Icon from "@insightfulscience/atomic-react/Icon";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import { string } from "prop-types";

const AcademyToCLink = ({ title, slug }) => {
	return (
		<Paragraph spacing={{ my: 2, sm: { mb: 0 } }}>
			<Link href={`#${slug}`}>
				<Icon name="chevron-right" /> {title}
			</Link>
		</Paragraph>
	);
};

AcademyToCLink.propTypes = {
	title: string.isRequired,
	slug: string.isRequired,
};

export default AcademyToCLink;
